import {
  GetAttendanceBreakConfigurationsRangeDocument,
  GetAttendanceBreakConfigurationsRangeQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type GetAttendanceBreakConfigurationsRange =
  GetAttendanceBreakConfigurationsRangeQuery['attendance']['breakConfigurationsForDatesConnection']['nodes'][number]

type BreakConfigurations = Pick<GetAttendanceBreakConfigurationsRange, 'breakConfigurations'>

export type AttendanceBreakConfigurations = BreakConfigurations['breakConfigurations'][number]

export type AttendanceBreakConfigurationsRange = Map<string, AttendanceBreakConfigurations[]>

export const useGetAttendanceBreakConfigurationsRange = (
  attendanceEmployeesPolicyId: string | null | undefined,
  startAt: string,
  endAt: string
) => {
  const { loading, data } = useQuery(GetAttendanceBreakConfigurationsRangeDocument, {
    variables: {
      attendanceEmployeesPolicyId: attendanceEmployeesPolicyId ?? '0', // Because of skip this 0 is not used. It's just to satisfy the type
      startAt,
      endAt,
    },
    skip: !attendanceEmployeesPolicyId,
  })

  const attendanceBreakConfigurationsRange =
    data?.attendance.breakConfigurationsForDatesConnection.nodes || []

  const breakConfigurationsRange = new Map()

  attendanceBreakConfigurationsRange.forEach((item) => {
    breakConfigurationsRange.set(item.date, item.breakConfigurations)
  })

  return {
    loading,
    breakConfigurationsRange,
  }
}
